import { Stack, Typography } from '@mui/material';
import { Switch } from '@engyalo/design-system';
import { ISettingsItemProps } from './types';
import { CustomIcon, SettingsItemWrapper } from './style';

const SettingsItem = ({ icon, title, description, onClick, isActive }: ISettingsItemProps) => {
  const isIconString = typeof icon === 'string';

  const iconClass = isIconString ? icon : '';

  return (
    <SettingsItemWrapper>
      <Stack direction="row" gap={1} flexGrow={1}>
        {isIconString ? <CustomIcon className={iconClass} data-testid="settings-icon" /> : icon}
        <Stack>
          <Typography variant="body2">{title}</Typography>
          {description && (
            <Typography variant="caption1" color="neutral.var80" maxWidth="35rem">
              {description}
            </Typography>
          )}
        </Stack>
      </Stack>
      <Switch checked={isActive} onChange={onClick} />
    </SettingsItemWrapper>
  );
};

export default SettingsItem;
